<template>

<div id="map_context" class="uk-width-1-1">
    <div class="uk-grid">
    <div class="uk-width-1-4@m graph-controller uk-grid-margin-small">

        <ul class="uk-flex-center graph-controller-tabs" uk-tab>
            <li id="chart-presets" :class="{'uk-active': controllerMode === 'presets'}"><a href="#"
                                                                        @click="controllerMode = 'presets'"><span
                    uk-icon="icon: play"></span></a></li>
            <li id="chart-metrics" :class="{'uk-active': controllerMode === 'fieldList'}"><a href="#"
                                                                        @click="controllerMode = 'fieldList'"><span
                    uk-icon="icon: list"></span></a></li>
            <li id="chart-settings" :class="{'uk-active': controllerMode === 'settings'}"><a href="#"
                                                                        @click="controllerMode = 'settings'"><span
                    uk-icon="icon: settings"></span></a></li>
        </ul>
        <!-- options accordion -->

        <div class='graph-controller-body uk-padding-small'>

            <!--  DEFAULT MAPS HTML -->
            <div v-if="controllerMode === 'presets'">
            
            </div>

            <!--  SET MAPS STUFF HTML -->
            <div v-if="controllerMode === 'fieldList'">
            <h4 class="control-section-header">Customize Chart Data</h4>
            
            </div>


            <!--  SETTINGS FOR MAPS -->
            <div v-if="controllerMode === 'settings'">
            <h4 class="control-section-header">Chart Settings</h4>
            
            </div>
        </div>
    </div>
    <div class="uk-width-expand" id="mapboxmap"></div>    
    </div>
</div>

</template>

<script>
import * as d3 from 'd3';
import mapboxgl from "mapbox-gl"
import geodata from '../../maps.json'
// console.log(geodata)

mapboxgl.accessToken = 'pk.eyJ1IjoibW9yZ2FuaGFydGxleSIsImEiOiJjandnbmxsemQxYTJuNDlwaWxzNGN2c2xxIn0.prr4h-_0VCceA0PW3mD9YQ';

// Vue.component('map', {
//     template: '<div id="map"></div>',
//     mounted(){
//         let map = new mapboxgl.Map({
//             container: 'mapboxmap',
//             style: 'mapbox://styles/mapbox/streets-v10'
//         });
//     }
// });

// Vue.component('marker', {
//     props: {
//         key: {
//             type: Number,
//             required: true,
//             validator: value => {
//                 // This should be the index of the array
//                 if(Number.isInteger(value)){
//                     return true
//                 }
//                 throw Error("must contain prop: key as an Integer") 
//             }
//         },
//         lat: {
//             type: Number,
//             default: 70
//         },
//         long: {
//             type: Number,
//             default: 30
//         },
//         properties:{
//             type: Object,
//             default: function(){
//                 return {
                    
//                 }
//             }
//         }
//     }
// });


export default {
    name: "map_context",
    props: {
        FeaturedCollection: {
            type: Object,
            default: function(){
                return {
                    type:"FeaturedCollection",
                    features: [],
                    map: {}
                }
            },
            validator: value => {
                if(value.hasOwnProperty("type")){
                    let propVal = value["type"];
                    if(propVal === "FeaturedCollection"){
                        return true
                    }
                    console.warn(`did not include property "type"`)
                }
                return false
            }
        }

    },
    data: function(){
        return {
            dataimages: [],
            markers: [],
            events:{},
            colorArray: ["#87D498","#9F85C6","#D34747"],
            binarycolorarray: ["#87D498", "#D34747"],
            atathresholdcolorarray: ["#ddd","#9F85C6","#87D498", "#D34747"],
            timeScaleColorArray: ["#ddd","#87D498","#829DC2","#9F85C6", "#D34747"]
        }
    },
    mounted(){   
        document.getElementById("top-menu").style.backgroundColor = "white"

        this.map = new mapboxgl.Map({
            container: 'mapboxmap',
            style: 'mapbox://styles/mapbox/streets-v10',
            zoom:11,
            center: [-77.470679, 37.572537]
        });

		geodata.features.forEach((marker, i, arr) => {
            this.initiateMarkers(marker, i, arr)
        }); 
        
    },
    beforeDestroy(){
        document.getElementById("top-menu").style.backgroundColor = "none"
    },
    methods: {
        initiateMarkers(marker, i, arr){
            // this markerContext has all data
            let markerContext = this.Marker('div', i)
            // now we can bind events and things to the markerContext if necessary
            let el = markerContext()
            // add the markerdata to the marker node
            el.marker_properties = marker.properties
            el.marker = marker

            // let detail_el = this.return_detail_element(el)
            // el.appendChild(detail_el)
            // el.geodata = arr
            el.onmouseover = (e) => this.showDetails(e)
            el.onmouseleave = (e) => this.hideDetails(e)
            // el.onclick = () => console.log('clicked point')
            // this.newEvent('test', el, (e) => {
            //     console.log('my new event')
            //     console.log(e)
            // });
            // el.dispatchEvent(event,'test')
            // console.dir(el)
            // if (i === 1){
            //     console.dir(markerContext)
            //     console.dir(el)
            // }
            ///SUPER FUCKING IMPORTANT --- THIS IS WHAT MAKES THE MARKERS MARKERS!
            this.markers.push(new mapboxgl.Marker({element:el}).setLngLat(marker.geometry.coordinates).addTo(this.map));
        },
        Marker(tag, i){
            let id = `marker-${i}`

            return function(){
                const el = document.createElement(String(tag));
                el.className = 'marker';
                el.setAttribute('id', id);
                el.setAttribute('index', i);
                return el
            }
        },
        return_detail_element(el){
            let properties = el.marker_properties
            let details_element = document.createElement('div')
            details_element.classList.add("data-detail")
            // details_element.style.opacity = 0
            for(var key in properties){
                let data_paragraph = document.createElement('p')
                data_paragraph.innerText = `${key}: ${properties[key]}`
                details_element.appendChild(data_paragraph)
            }
            // console.log('details element below')
            // console.dir(details_element)
            // console.log(details_element)
            return details_element
        },
        newEvent(name, el, cb){
            let event = new Event(String(name));
            // console.log(event)
            el.addEventListener(String(name), cb);
            this.events[String(name)] = {...event};
            // console.log(this.events)
        },
        showDetails(e){
            let el = e.target
            el.style.zIndex = 1000 
            let detail_el = this.return_detail_element(el)
            el.appendChild(detail_el)
            detail_el.style.opacity = 0.8
            console.dir(el)
        },
        hideDetails(e){
            let marker_el = e.target
            marker_el.style.zIndex = ""
            marker_el.removeChild(marker_el.childNodes[0])
            console.log('mouseleave')
        },
        updateColor(color, property){
            if(property !== undefined){

            }

        },
        change(el_arg, cb){
            let el = el_arg
            return function(update_property_arg){
                let err;
                let updateProperty = update_property_arg;
                if(!el.hasOwnProperty(String(updateProperty))){
                    el[String(updateProperty)] = null
                }
                let currentValue = el[String(updateProperty)]
                if(currentValue !== null){
                    let checkcb = cb(err, currentValue)
                } else {
                    console.warn(`null value passed for updateProperty: ${updateProperty}`)
                }
                return function(newValue_arg, cb){
                    let newValue = newValue_arg;
                    cb(updateProperty, newValue)
                }
            }
        },
        generateColorScale(){
            let m = Math.random()
        },
        loopOverMarkers(){
            this.markers = this.markers.reduce((acc,cv) => {
                // let init = change(cv, (err, currentValue, data) => {

                // })
                // let update = init()
                acc.push(cv)
                return acc
            }, [])
        },
        changeBackgroundColor(el_arg){
            let el = el_arg;
            return function(color){
                el.style.backgroundColor = String(color)
            }
        },
        returnCollection(){
            return {
                type:"FeaturedCollection",
                features: []
            }
        },
        
        SetAttributes(el, ...rest){
            if(rest.length % 2 !== 0){
                for(let i = 1; i < rest.length; i++){
                    el.setAttribute(rest[i-1], rest[i])
                }
            }
            throw Error("rest array has odd number of values")
        }

    }

}
</script>

<style lang="less">
    @import "../../node_modules/mapbox-gl/src/css/mapbox-gl.css";

    canvas {
        left: 0;
    }
    #mapboxmap {
        // position: fixed;
        // transform: translateX(-50%);
        top: 0;
        left: 0;
        // width: 00%;
        height: 100vh;
    }
    .marker {
        width: 10px;
        height: 10px;
        background-color: navy;
        border-radius: 50%;
        position: absolute;
        display: inline-block;
        z-index: 10;
        // transform: translate()
    }
    .data-detail {
        background: white;
        transition: all 333ms;
        opacity: 0;
        width: 300px;
        max-height: 200px;
        z-index: 9999;
        position: relative;
        overflow-y: scroll;
        text-align: left;
    }
    .data-detail p {
        margin: 0;
    }
</style>